import { render, staticRenderFns } from "./confetti.vue?vue&type=template&id=67cfb280&scoped=true&"
import script from "./confetti.vue?vue&type=script&lang=js&"
export * from "./confetti.vue?vue&type=script&lang=js&"
import style0 from "./confetti.vue?vue&type=style&index=0&id=67cfb280&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cfb280",
  null
  
)

export default component.exports